import NavbarDisplay from '../navbar/navbar-display';
import CookieHelper from '../helpers/cookie-helper';
import PayoutModalHelper from '../helpers/payout-modal-helper';

/**
 * Credit class.
 */
class Credit {

    
    /**
     * Credit Constructor.
     * 
     * @param api Api
     */
    constructor(api) {
        this._api = api;
        this._navbar = new NavbarDisplay();
    }

    /**
     * Gets user credit info.
     * 
     * @param user User
     */
    getCredit(user) {

        if (user.isLogggedIn()) {
            this._api.send('/user/get-credit', {'username': CookieHelper.get('uName')}, (response) => {
                
                if (response.Status !== 1) {
                    console.log('Get Credit Failed. No response data.');
                } else {
                    user.username = CookieHelper.get('uName');
                    this._navbar.showUpdatedCredit(user, response);
                    console.log('Credit updated.');
                    
                }
              }, () => {
                  console.log('Get Credit Failed.');
              });
        } else {
            var logoutEvent = new CustomEvent("logout");
            window.dispatchEvent(logoutEvent);
        }
    }

    /**
     * Gets async credit.
     * 
     * @param user User
     */
    getAsyncCredit(user) {

        var self = this;
        return new Promise(function(resolve,reject){
            if (user.isLogggedIn()) {
                self._api.send('/user/get-credit', {'username': CookieHelper.get('uName')}, (response) => {
                    
                    if (response.Status !== 1) {
                        console.log('Get Credit Failed. No response data.');
                    } else {
                        resolve(response.Credit);
                        
                    }
                  }, () => {
                      console.log('Get Credit Failed.');
                      reject('Get Credit Failed.');
                  });
            } else {
                var logoutEvent = new CustomEvent("logout");
                window.dispatchEvent(logoutEvent);
            }
        });
    }

    /**
     * Requests payout PIN.
     * 
     * @param user User
     */
    requestPayout(user) {
        if (user.isLogggedIn()) {
            this._api.send('/user/request-payout', {'username': CookieHelper.get('uName')}, (response) => {
                
                if (response.Status !== 1) {
                    console.log('Payout Failed. No response data.');
                } else {
                    PayoutModalHelper.openModal();
                    PayoutModalHelper.bind(response.PayoutPIN);
                }
              }, () => {
                  console.log('Get Credit Failed.');
              });
        } else {
            var logoutEvent = new CustomEvent("logout");
            window.dispatchEvent(logoutEvent);
        }
    }

}

export default Credit;



//////////////////
// WEBPACK FOOTER
// ./src/games/dog-racing/js/credit/credit.js
// module id = 238
// module chunks = 11